<div class="container" id="data-table-comp">
  <div>
    <app-custom-table
      [data]="this.data"
      [loading]="this.loading"
      [editRow]="true"
      (editRowHandler)="this.editRow($event)"
      highlightColor="#ff454533"
      highlightControlKey="found"
      [removalColumns]="['id']"
      [dateKeys]="['generated_on']"
      [headerMappingFunction]="headerMappingHelper"
      rowIdKey="directory_name"
      [columns]="this.options"
      [defaultShowingColumns]="this.defaultShowingColumns"
      [inMenuButtonConfig]="this.inMenuButtonConfig"
      [stickyFieldKeys]="['directory_name']"
      [headerTooltipsAccessor]="tooltipsAccessor"
      >
      <span class="custom-tooltip" style="margin-right: 10px">
        <div><i class="zmdi zmdi-info-outline"></i></div>
        <span
          >The records that are highlighted in red represent those with a
          missing key and log file.
          <br />
          This may be because the folder is not found in the traces locator or
          the AWS path provided, or that the paths exist but the key and/or log
          files do not exist there.
        </span>
      </span>
      <!-- <button mat-button (click)="rebuildDataTable()">Rebuild Table</button> -->
    </app-custom-table>
  </div>
</div>

@if (showEditModal) {
  <div
    class="edit-modal data-table-comp-modal overlay-behavior"
    >
    <div class="modal-body">
      <div class="modal-header">
        <input
          type="file"
          (change)="onFileSelected($event)"
          class="file-input"
          multiple
          #fileUpload
          />
        <div class="file-upload">
          <button
            mat-mini-fab
            style="background-color: #2196f3"
            color="primary"
            class="upload-btn"
            (click)="fileUpload.click()"
            >
            <i class="zmdi zmdi-attachment-alt"></i>
          </button>
          <div id="files-preview-section"></div>
        </div>
        <p style="display: flex; gap: 10px; margin: 0px">
          <button
            mat-raised-button
            (click)="parseFiles()"
            >
            Parse
          </button>
          <button
            mat-raised-button
            (click)="saveChanges()"
            [disabled]="saving"
            class="save-button"
            [class.saving]="saving"
            >
            @if (!saving) {
              <span>Save</span>
            }
            @if (saving) {
              <span class="saving-content">
                <i class="zmdi zmdi-refresh zmdi-hc-spin"></i>
                Saving...
              </span>
            }
          </button>
        </p>
      </div>
      <div class="form-input comment-input">
        <label>
          <input [(ngModel)]="activeRow['comment']" />
          <span>Comment</span>
        </label>
      </div>
      <!-- Success message -->
      @if (saveSuccess) {
        <div class="save-success-message" [@fadeInOut]>
          <i class="zmdi zmdi-check-circle"></i>
          <span>Changes saved successfully!</span>
        </div>
      }
      <div
        class="pretty-parsed-data"
        [innerHTML]="syntaxHighlight(this.dataValues)"
      ></div>
      <!-- <div class="params-form-section">
      <div class="input-container" *ngFor="let key of this.getObjectKeys(this.activeRow)">
        <label>{{key}}</label>
        <input [value]="activeRow[key]" (change)="changeValue($event, key)" />
      </div>
    </div> -->
  </div>
</div>
}

@if (showSaveModalDialog) {
  <div
    id="data-table-save-dialog"
    class="overlay-behavior"
    >
    <div class="dialog-body">
      You have unsaved changes.
      <div class="buttons-container">
        <button (click)="discardChanges()" class="danger">Discard</button>
        <button (click)="saveChanges()" class="primary">Save</button>
      </div>
    </div>
  </div>
}
